var Bins = (function () {

    var _opts = {
        inputs: '.js-bin-input',
        c_key: 'bins_order'
    };

    var _updateInputs = function () {
        if( $.cookie( _opts.c_key ) ) {
            var i = 0;
            var data = JSON.parse( $.cookie( _opts.c_key ) );

            for (i; i < data.length; i++ ) $('[name="'+ data[i][0] +'"]').attr('value',data[i][1] );
        }
    };

    var _updateStorage = function(e) {

        var values = [];
        $( _opts.inputs ).each(function () {
            if( this.value === '') return true;

            values.push([this.name, this.value]);
        });

        // expires in .12 days which is 2 hours
        $.cookie( _opts.c_key , JSON.stringify(values), { expires: 0.12 });
    };

    var _addEvents = function() {
        _updateInputs();
        $( _opts.inputs ).change( _updateStorage )
    };

    var init = function () {
      if( $(_opts.inputs).length ) _addEvents();
    };

    
    return {
        init: init
    }
    
})();

$( document ).ready( Bins.init );